import React, { useEffect } from "react";
import {
  Cell,
  useTableContext,
} from "@sonder/ui/source/styled/fragments/Table";
import { HistoryTaskData } from "core/queries/GetHistoryTasks";
import { getTaskInternalRef } from "core/queries/mappers";
import { PriorityBadge } from "tasks/components/PriorityBadge";
import { formatAccountName, formatDate } from "tasks/helpers";

export const HistoryTaskRow = (props: HistoryTaskData) => {
  const {
    id: taskId,
    assignee,
    completedAt,
    createdAt,
    name,
    priority,
  } = props;
  const { selected } = useTableContext();

  useEffect(() => {
    if (selected === taskId) {
      const numericTaskId = selected.split("|").pop();
      window.open(`/task/${numericTaskId}`, "_blank");
    }
  }, [selected]);

  return (
    <>
      <Cell rowStart rowKey={taskId}>
        {name}
      </Cell>
      <Cell rowKey={taskId}>
        {priority && <PriorityBadge priority={priority} />}
      </Cell>
      <Cell rowKey={taskId}>{getTaskInternalRef(props)}</Cell>
      <Cell rowKey={taskId}>
        {assignee && <div>{formatAccountName(assignee)}</div>}
      </Cell>
      <Cell rowKey={taskId}>{formatDate(createdAt)}</Cell>
      <Cell rowEnd rowKey={taskId}>
        {completedAt ? formatDate(completedAt) : ""}
      </Cell>
    </>
  );
};
